module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-light-1a9d17a0eac3fed9f6851ad4383bb5a6.png";